export const levelColor = {
  safe: '#4CAF50',
  moderate: '#FFC107',
  risk: '#FF7043',
  danger: '#F44336'
};
